export const $ImageViewerModuleName = "imageViewer";

export type TImageViewerState = {
    activeIndex: number;
};
